import { render, staticRenderFns } from "./SecondSectionItem.vue?vue&type=template&id=234723b9&"
import script from "./SecondSectionItem.vue?vue&type=script&lang=js&"
export * from "./SecondSectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports